module.exports = __webpack_public_path__ + "img/90dd83a.png";